<template>
  <router-view/>
</template>

<script>
export default {
  name: 'Keanggotaan'
}
</script>
